import React from 'react';
import { motion } from 'framer-motion';
import { Player, PlayerColor } from '../store/gameStore';

interface PlayerTokenProps {
  player: Player;
  isActive: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const colorMap: Record<PlayerColor, string> = {
  red: 'bg-gradient-to-br from-red-400 to-red-600',
  blue: 'bg-gradient-to-br from-blue-400 to-blue-600',
  green: 'bg-gradient-to-br from-green-400 to-green-600',
  yellow: 'bg-gradient-to-br from-yellow-400 to-yellow-600',
  purple: 'bg-gradient-to-br from-purple-400 to-purple-600',
  orange: 'bg-gradient-to-br from-orange-400 to-orange-600',
};

const sizeMap = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-12 h-12 text-sm',
  lg: 'w-16 h-16 text-base',
};

const PlayerToken: React.FC<PlayerTokenProps> = ({ player, isActive, size = 'md' }) => {
  return (
    <motion.div
      className={`
        ${colorMap[player.color]}
        ${sizeMap[size]}
        rounded-full 
        flex items-center justify-center 
        font-bold text-white
        shadow-lg
        border-2 border-white/30
        ${player.isInPrison ? 'opacity-50' : ''}
        ${isActive ? 'ring-4 ring-white ring-opacity-100' : ''}
      `}
      animate={isActive ? {
        scale: [1, 1.1, 1],
        boxShadow: [
          '0 0 0 0 rgba(255, 255, 255, 0)',
          '0 0 20px 5px rgba(255, 255, 255, 0.5)',
          '0 0 0 0 rgba(255, 255, 255, 0)',
        ],
      } : {}}
      transition={isActive ? {
        duration: 1.5,
        repeat: Infinity,
      } : {}}
      title={player.name}
    >
      {player.name.charAt(0).toUpperCase()}
    </motion.div>
  );
};

export default PlayerToken;
